import { type IDropdownItem } from 'shared/ui'
import { type SmartView } from 'entities/SmartViews/model/SmartView'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

const typeEditSmartView = 'edit_smart_view'

type IActionEditSmartView = {
  inbox: SmartView
  item: IDropdownItem
}

export const menuEditSmartView = (): IDropdownItem => {
  return {
    id: typeEditSmartView,
    iconL: 'edit',
    label: 'Edit',
  }
}

export const actionEditSmartView = async (
  { inbox, item }: IActionEditSmartView,
  store: ConversationMenuStore
) => {
  if (item.id === typeEditSmartView) {
    store.smartViewsMenuStore.onOpenModalEdit(inbox)
  }
}
